module.exports = __webpack_public_path__ + "static/media/typescript.334b7b2d.svg";